export default __webpack_public_path__ + "static/media/chu_amienspicardie_logo.1c43e108.png";